import {checkIfUnfinishedTutorialMatch} from '../matches/tutorialMatchVisibility';

/**
 * Что показать о записи обучения в истории матчей (плашка и детали матча).
 *
 * Запись о главе создается на старте прохождения (есть статус и прогресс), у
 * старых записей и у записей, сохраненных только при завершении главы, — в
 * момент прохождения (прогресса нет, время начала совпадает со временем
 * окончания, длительности нет). Недоигранные записи видны в истории всем.
 *
 * @returns {null|{
 *   isRecordedFromStart: boolean,
 *   isUnfinished: boolean,
 *   historyDate: string|null,
 *   durationMs: number|null,
 *   stepNumber: number|null,
 *   stepsCount: number|null,
 *   stepIndex: number|null,
 *   stepId: string|null,
 * }}
 */
export const getTutorialMatchInfo = (match) => {
  if (!match?.isTutorial) {
    return null;
  }
  // Прогресс есть только у записей, созданных на старте главы: запись,
  // сохраненная уже при ее завершении (сервер был недоступен на старте),
  // статус получает, а ни начала, ни длительности у нее нет
  const isRecordedFromStart = Boolean(match.tutorialStatus && match.tutorialProgress);
  const isUnfinished = checkIfUnfinishedTutorialMatch(match);

  const progress = match.tutorialProgress || null;
  const stepsCount = Number.isInteger(progress?.stepsCount) && progress.stepsCount > 0 ? progress.stepsCount : null;
  const stepIndex = Number.isInteger(progress?.stepIndex) ? progress.stepIndex : null;
  // Пройденная глава продвигает шаг за последний — показывать «34 из 33» незачем
  const stepNumber = stepIndex !== null && stepsCount !== null ? Math.min(stepIndex + 1, stepsCount) : null;

  let durationMs = null;
  if (isRecordedFromStart && match.startedAt) {
    if (isUnfinished) {
      const lastActivityAt = match.lastActivityAt ? new Date(match.lastActivityAt).getTime() : NaN;
      const startedAt = new Date(match.startedAt).getTime();
      durationMs = Number.isFinite(lastActivityAt) && Number.isFinite(startedAt)
        ? Math.max(0, lastActivityAt - startedAt)
        : null;
    } else {
      durationMs = Number.isFinite(match.durationMs) ? match.durationMs : null;
    }
  }

  return {
    isRecordedFromStart,
    isUnfinished,
    // У недоигранной главы окончания нет — в истории она датирована стартом
    historyDate: match.finishedAt || match.startedAt || null,
    durationMs,
    stepNumber,
    stepsCount,
    stepIndex,
    stepId: progress?.stepId ?? null,
  };
};
